export default __webpack_public_path__ + "img/6b2741d56cec1043b00364e7562a4add.svg";